export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const optimizeImageProps = (src, alt, { width, height, srcSet } = {}) => ({
  src,
  alt,
  loading: 'lazy',
  decoding: 'async',
  ...(srcSet && { srcSet }),
  ...(width && { width }),
  ...(height && { height }),
  style: { maxWidth: '100%', height: 'auto' }
});

export const createSrcSet = (basePath) => {
  return [
    `${basePath}?w=320 320w`,
    `${basePath}?w=640 640w`,
    `${basePath}?w=1280 1280w`,
    `${basePath}?w=1920 1920w`
  ].join(', ');
};
